export const initialConfig = {
  parentHashFromHandshake: "",
};